import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { CallArrivalDataObj } from './call-arrival.models';

@Injectable({
    providedIn: 'root'
})
export class CallArrivalService {

    constructor(
        private cvApiService: CVApiService
    ) { }

    async loadData(moduleKey: string, isAutoRefresh: boolean, isFirstLoad: boolean) {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (error) {
            console.error("Failed getting module render endpoint");
            throw error;
        }
        try {
            const url = "/api/v2/dashboards/modules/callArrivalData/" +
                moduleKey + "?isAutoRefresh=" + !!isAutoRefresh + "&isFirstLoad=" + !!isFirstLoad;
            const response = await this.cvApiService.get<CallArrivalDataObj>(url, renderEndpoint);
            if (response.status_code !== 200)
                throw response;
            else
                return response.data;
        } catch (error) {
            console.error("Failed getting call arrival data.");
            throw error;
        }
    }
}
